import React, { useState } from "react";
import "./ShopDetails.css";

import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../Features/Cart/cartSlice";

import Filter from "../Filters/Filter";
import { Link, useSearchParams } from "react-router-dom";
import { FiHeart } from "react-icons/fi";
import { FaStar } from "react-icons/fa";
import { IoFilterSharp, IoClose } from "react-icons/io5";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";
import { FaCartPlus } from "react-icons/fa";
import toast from "react-hot-toast";
import axios from "axios";
import * as backendModule from "../../../modules/backendModule";
import Spinner from "../../Spinner";

const ShopDetails = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const collectionCategories = { men: [1, 4], women: [2, 5], children: [3] };
  const initialCollection = searchParams.get("collection");

  const [wishList, setWishList] = useState({});
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [products, setProducts] = React.useState([]);
  const [paginationMessage, setPaginationMessage] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [paginationSpinner, setPaginationSpinner] = React.useState(false);
  const [spinner, setSpinner] = React.useState(false);
  const [categoryFilter, setCategoryFilter] = React.useState(
    collectionCategories[initialCollection]
      ? { Name: initialCollection, IDs: collectionCategories[initialCollection] }
      : null
  );
  const [brandFilter, setBrandFilter] = React.useState(null);
  const [priceFilter, setPriceFilter] = useState(null);
  const [mobFilters, setMobFilters] = React.useState(false);

  const getAllProducts = (offset, limit, categoryFilter, brandFilter, priceFilter) => {
    setPaginationMessage(null);
    setSpinner(true);
    axios({
      method: "POST",
      url: `${backendModule.backendURL}/products/getAllProducts`,
      data: {
        filters: [
          categoryFilter !== null ? {
            name: 'CategoryID',
            op: categoryFilter.IDs ? 'in' : 'eq',
            value: categoryFilter.IDs || categoryFilter.ID
          } : null,
          brandFilter !== null ? { name: 'BrandID', op: 'eq', value: brandFilter.ID } : null,
          priceFilter !== null ? { name: 'Price', op: 'between', value: priceFilter } : null,
        ],
        offset: offset,
        limit: limit
      },
      ...backendModule.axiosConfig,
    }).then(res => {
      if (res.data.status === "ok") {
        setProducts(res.data?.data);
      } else {
        setError('Došlo je do serverske greške');
      }
    }).catch(() => {
      setError('Došlo je do serverske greške');
    }).finally(() => {
      setSpinner(false);
    });
  }

  const getProductsPagination = (offset, limit) => {
    axios({
      method: "POST",
      url: `${backendModule.backendURL}/products/getAllProducts`,
      data: {
        filters: [],
        offset: offset,
        limit: limit
      },
      ...backendModule.axiosConfig,
    }).then(res => {
      if (res.data.status === "ok") {
        if (res.data.data.length === 0) {
          setPaginationMessage('Nema više proizvoda');
        }
        else {
          setProducts(prev => [...prev, ...res.data.data]);
        }
      } else {
        setPaginationMessage('Došlo je do serverske greške');
      }
    }).catch(() => {
      setPaginationMessage('Došlo je do serverske greške');
    }).finally(() => {
      setPaginationSpinner(false);
    });
  }

  const handleWishlistClick = (productID) => {
    setWishList((prevWishlist) => ({
      ...prevWishlist,
      [productID]: !prevWishlist[productID],
    }));
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  const cartItems = useSelector((state) => state.cart.items);

  const handleAddToCart = (product) => {
    const productInCart = cartItems.find(
      (item) => item.ID === product.ID
    );

    if (productInCart && productInCart.quantity >= 20) {
      toast.error("Product limit reached", {
        duration: 2000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
    } else {
      dispatch(addToCart(product));
      toast.success(`Added to cart!`, {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    }
  };

  const resetFilters = () => {
    setCategoryFilter(null);
    setBrandFilter(null);
    setPriceFilter(null);
    setSearchParams({});
  }

  React.useEffect(() => {
    getAllProducts(0, 12, categoryFilter, brandFilter, priceFilter);
    console.log(categoryFilter, brandFilter, priceFilter);
  }, [categoryFilter, brandFilter, priceFilter]);

  return (
    <>
      <div className="shopDetails">
        <div className="shopDetailMain">
          <div onClick={() => {setMobFilters(m => !m)}} className="filtersMobBtn">
            {!mobFilters && <p>Uključi filtere</p>}
            {mobFilters && <p>Ugasi filtere</p>}
          </div>
          <div className={`shopDetails__left ${mobFilters ? 'activeMobFilters' : ''}`}>
            <Filter resetFilters={resetFilters} setMobFilters={setMobFilters} setCategoryFilter={setCategoryFilter} setBrandFilter={setBrandFilter} setPriceFilter={setPriceFilter} />
          </div>
          <div className="shopDetails__right">
            <div className="shopDetailsProducts">
              {!spinner && <div className="shopDetailsProductsContainer">
                {products?.map((product) => (
                  <div className="sdProductContainer">
                    <div className="sdProductImages">
                      <Link to={`/Product?id=${product.ID}`} onClick={scrollToTop}>
                        <img
                          src={`${backendModule.backendURL}/${product.ImagePath}`}
                          alt=""
                          className="sdProduct_front"
                        />
                        <img
                          src={`${backendModule.backendURL}/${product.ImagePath2}`}
                          alt=""
                          className="sdProduct_back"
                        />
                      </Link>
                      <h4 onClick={() => handleAddToCart(product)}>
                        DODAJ U KORPU
                      </h4>
                    </div>
                    <div
                      className="sdProductImagesCart"
                      onClick={() => handleAddToCart(product)}
                    >
                      <FaCartPlus />
                    </div>
                    <br></br>
                    <div className="sdProductInfo">
                      <div className="sdProductNameInfo">
                        <Link to="/product" onClick={scrollToTop}>
                          <h5>{product.Name}</h5>
                        </Link>

                        <p>{Number(product.Price).toFixed(2)} KM</p>
                        <div className="sdProductRatingReviews">
                          <div className="sdProductRatingStar">
                            <FaStar color="#FEC78A" size={10} />
                            <FaStar color="#FEC78A" size={10} />
                            <FaStar color="#FEC78A" size={10} />
                            <FaStar color="#FEC78A" size={10} />
                            <FaStar color="#FEC78A" size={10} />
                          </div>
                          <span>100 + korisnika ocijenilo</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>}
              {spinner && <Spinner color="black" style={{ width: "64px", height: "50px", color: "black" }} />}
            </div>
            {products?.length > 11 && <div className="shopDetailsPagination">
              {!paginationSpinner && !paginationMessage ? <div onClick={() => { setPaginationSpinner(true); getProductsPagination(products?.length, 12) }} className='products__container__prodGrid__pagination__button'>
                <p>Učitaj još proizvoda</p>
              </div> : null}
              {paginationSpinner && <Spinner style={{ width: '64px', height: '50px', marginLeft: 'auto', marginRight: 'auto', display: 'block' }} color='#1A1A1A' />}
              {paginationMessage && <p style={{ color: 'maroon', fontSize: '15px' }}>{paginationMessage}</p>}
            </div>}
          </div>
        </div>
      </div>
      {/* Drawer */}
      <div className={`filterDrawer ${isDrawerOpen ? "open" : ""}`}>
        <div className="drawerHeader">
          <p>Filter By</p>
          <IoClose onClick={closeDrawer} className="closeButton" size={26} />
        </div>
        <div className="drawerContent">
          <Filter />
        </div>
      </div>
    </>
  );
};

export default ShopDetails;
